import React from 'react';
import Text from '../text/Text';

interface Props {
  suffix?: JSX.Element | JSX.Element[] | string;
  prefix?: JSX.Element | JSX.Element[] | string;
  isSearchable: boolean;
  placeholder: string;
  showMenu: boolean;
  getSearchField: (
    hasPlaceholder: boolean,
  ) => string | JSX.Element | JSX.Element[];
}

const ControlPanel = ({
  prefix,
  isSearchable,
  getSearchField,
  placeholder,
  showMenu,
  suffix,
}: Props): string | JSX.Element | JSX.Element[] => {
  return (
    <div className="d-flex w-100 justify-content-space">
      <div className="d-flex  align-items-center gap-4 w-100">
        {prefix ? (
          <span className="d-flex align-items-center justify-content-center">
            {prefix}
          </span>
        ) : null}

        {isSearchable && showMenu ? (
          getSearchField(true)
        ) : (
          <Text color="subtitle2" className="text-nowrap">
            {placeholder}
          </Text>
        )}
      </div>

      {suffix ? (
        <span className="d-flex align-items-center justify-content-center">
          {suffix}
        </span>
      ) : null}
    </div>
  );
};

export default ControlPanel;
